export default {
    computed: {
        availableProgress() {
            return this.currentQuestionIds.length
        },
        questionsProgress() {
            if (this.progress) {
                return this.progress
            }
            if (this.$page.props.survey.responses.length === 0) {
                return 0
            }
            return this.responsesCount
        },
        responses() {
            return this.$page.props.survey.responses
        },
        answeredQuestionIds() {
            return this.responses.map((x) => x.survey_question_id)
        },
        responsesCount() {
            return this.responsesQuestionsIntersect.length
        },
        responsesQuestionsIntersect() {
            return this.currentQuestionIds.filter((x) =>
                this.answeredQuestionIds.includes(x)
            )
        },
    },
}
